<div _ngcontent-seeker-c203="" class="ng-star-inserted">
    <header _ngcontent-seeker-c203="">
        <h2 _ngcontent-seeker-c203="" class="heading-lg mb-0">Similar jobs</h2>
        <!---->
    </header>
    <jobs-carousel _ngcontent-seeker-c203="" _nghost-seeker-c197="" class="ng-star-inserted two-columns">
        <div _ngcontent-seeker-c197="" class="jobs-container">
            <job-overview _ngcontent-seeker-c197="" _nghost-seeker-c182="" class="ng-star-inserted">
                <div _ngcontent-seeker-c182="" class="job-overview ellipsize-title">
                    <!---->
                    <!---->
                    <div _ngcontent-seeker-c182="">
                        <div _ngcontent-seeker-c182="" class="logo ng-star-inserted" data-snagtag="company-logo">
                            <ngui-in-view _ngcontent-seeker-c182="" _nghost-seeker-c183="" class="in-view">
                                <div _ngcontent-seeker-c182="" class="ng-star-inserted"><img _ngcontent-seeker-c182=""
                                        src="https://media.api.snagajob.com/0f4fa111c51a4321be4e2f068b3faccc/?width=40"
                                        alt="DoorDash Logo" class="ng-star-inserted">
                                    <!---->
                                    <!---->
                                </div>
                                <!---->
                                <!---->
                            </ngui-in-view>
                        </div>
                        <!---->
                        <!---->
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-descr">
                        <div _ngcontent-seeker-c182="" class="job">
                            <h2 _ngcontent-seeker-c182="" class="job__position heading-sm layoutType ng-star-inserted"
                                data-snagtag="job-title"><a _ngcontent-seeker-c182="" href="/jobs/655964903">Restaurant
                                    Delivery - Start Delivering Today</a></h2>
                            <!---->
                            <h3 _ngcontent-seeker-c182="" class="job__company body-sm ng-star-inserted"
                                data-snagtag="company-name">DoorDash</h3>
                            <!---->
                        </div>
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-location">
                        <div _ngcontent-seeker-c182="" class="job">
                            <div _ngcontent-seeker-c182="" class="job--location ng-star-inserted"
                                data-snagtag="job-location"><span _ngcontent-seeker-c182="" class="ng-star-inserted">
                                    <!---->
                                </span>
                                <!----> Alliance, OH 44601
                            </div>
                            <!---->
                        </div>
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-details">
                        <div _ngcontent-seeker-c182="" class="job">
                            <!----><span _ngcontent-seeker-c182="" class="job__detail ng-star-inserted">
                                <!----> Full-time, Part-time
                            </span>
                            <!---->
                            <!---->
                            <!---->
                        </div>
                    </div>
                    <ribbon _ngcontent-seeker-c182="" _nghost-seeker-c185="">
                        <ul _ngcontent-seeker-c185="" class="banners ng-star-inserted">
                            <li _ngcontent-seeker-c185="" class="foryou ng-star-inserted"><strong
                                    _ngcontent-seeker-c185="">For You</strong></li>
                            <li _ngcontent-seeker-c185="" class="urgentlyHiring ng-star-inserted"><strong
                                    _ngcontent-seeker-c185="">Urgently Hiring</strong></li>
                            <!---->
                        </ul>
                        <!---->
                    </ribbon>
                </div>
            </job-overview>
            <job-overview _ngcontent-seeker-c197="" _nghost-seeker-c182="" class="ng-star-inserted">
                <div _ngcontent-seeker-c182="" class="job-overview ellipsize-title">
                    <!---->
                    <!---->
                    <div _ngcontent-seeker-c182="">
                        <div _ngcontent-seeker-c182="" class="logo ng-star-inserted" data-snagtag="company-logo">
                            <ngui-in-view _ngcontent-seeker-c182="" _nghost-seeker-c183="" class="in-view">
                                <div _ngcontent-seeker-c182="" class="ng-star-inserted"><img _ngcontent-seeker-c182=""
                                        src="https://media.api.snagajob.com/26916c6850254b36a78904f4874cb876/?width=40"
                                        alt="Caviar Logo" class="ng-star-inserted">
                                    <!---->
                                    <!---->
                                </div>
                                <!---->
                                <!---->
                            </ngui-in-view>
                        </div>
                        <!---->
                        <!---->
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-descr">
                        <div _ngcontent-seeker-c182="" class="job">
                            <h2 _ngcontent-seeker-c182="" class="job__position heading-sm layoutType ng-star-inserted"
                                data-snagtag="job-title"><a _ngcontent-seeker-c182="" href="/jobs/653397724">Restaurant
                                    Delivery</a></h2>
                            <!---->
                            <h3 _ngcontent-seeker-c182="" class="job__company body-sm ng-star-inserted"
                                data-snagtag="company-name">Caviar</h3>
                            <!---->
                        </div>
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-location">
                        <div _ngcontent-seeker-c182="" class="job">
                            <div _ngcontent-seeker-c182="" class="job--location ng-star-inserted"
                                data-snagtag="job-location"><span _ngcontent-seeker-c182="" class="ng-star-inserted">
                                    <!---->
                                </span>
                                <!----> Alliance, OH 44601
                            </div>
                            <!---->
                        </div>
                    </div>
                    <div _ngcontent-seeker-c182="" class="job-details">
                        <div _ngcontent-seeker-c182="" class="job">
                            <!----><span _ngcontent-seeker-c182="" class="job__detail ng-star-inserted">
                                <!----> Full-time, Part-time
                            </span>
                            <!---->
                            <!---->
                            <!---->
                        </div>
                    </div>
                    <ribbon _ngcontent-seeker-c182="" _nghost-seeker-c185="">
                        <ul _ngcontent-seeker-c185="" class="banners ng-star-inserted">
                            <li _ngcontent-seeker-c185="" class="foryou ng-star-inserted"><strong
                                    _ngcontent-seeker-c185="">For You</strong></li>
                            <li _ngcontent-seeker-c185="" class="urgentlyHiring ng-star-inserted"><strong
                                    _ngcontent-seeker-c185="">Urgently Hiring</strong></li>
                            <!---->
                        </ul>
                        <!---->
                    </ribbon>
                </div>
            </job-overview>
            <!---->
        </div>
        <div _ngcontent-seeker-c197="" class="footer__container">
            <div _ngcontent-seeker-c197="" class="footer ng-star-inserted"><button _ngcontent-seeker-c197=""
                    aria-label="Previous" mat-icon-button=""
                    class="mat-focus-indicator left-arrow mat-icon-button mat-button-base"><span
                        class="mat-button-wrapper"><i _ngcontent-seeker-c197=""
                            class="icon-functional icon-left-toggle"></i></span><span matripple=""
                        class="mat-ripple mat-button-ripple mat-button-ripple-round"></span><span
                        class="mat-button-focus-overlay"></span></button>
                <ul _ngcontent-seeker-c197="" class="pagination-circles">
                    <li _ngcontent-seeker-c197="" class="pagination-circle ng-star-inserted active"></li>
                    <li _ngcontent-seeker-c197="" class="pagination-circle ng-star-inserted"></li>
                    <li _ngcontent-seeker-c197="" class="pagination-circle ng-star-inserted"></li>
                    <li _ngcontent-seeker-c197="" class="pagination-circle ng-star-inserted"></li>
                    <li _ngcontent-seeker-c197="" class="pagination-circle ng-star-inserted"></li>
                    <!---->
                </ul><button _ngcontent-seeker-c197="" aria-label="Next" mat-icon-button=""
                    class="mat-focus-indicator right-arrow mat-icon-button mat-button-base"><span
                        class="mat-button-wrapper"><i _ngcontent-seeker-c197=""
                            class="icon-functional icon-right-toggle"></i></span><span matripple=""
                        class="mat-ripple mat-button-ripple mat-button-ripple-round"></span><span
                        class="mat-button-focus-overlay"></span></button>
            </div>
            <!---->
        </div>
    </jobs-carousel>
    <!---->
    <!---->
</div>